<template >
    <div class="page-header align-items-start min-vh-100 position-relative login-background">
        <span class="mask bg-gradient-light opacity-7"></span>
        <div class="container my-auto">
            <div class="row">
                <div class="col-lg-4 col-md-8 col-12 mx-auto">
                    <div class="card z-index-0 fadeIn3 fadeInBottom">                        
                        <div class="card-body">
                            <div class="text-center">
                                <img src="../../assets/img/Veeboek-logo.png" class="logo mb-2" alt="Vee Boek">
                            </div>
                            <div class="text-start mt-3">
                                <form @submit.prevent="verifyMfa" id="verifyMfaForm">
                                    <div class="mb-3">
                                        <label class="form-label">{{ $t('login.Mfa_code') }} *</label>
                                        <input type="text" class="input" v-model.trim="code">
                                        <span class="error-message text-danger" v-if="!code && attemptedLogin">{{ $t('login.Enter_6_digit_code') }}</span>
                                    </div>

                                    <div class="text-center">                                        
                                        <button type="submit" class="btn bg-gradient-success btn-md w-100 my-3">{{ $t('login.Verify') }}</button>
                                    </div>
                                    
                                    <div class="text-center">
                                        <router-link to="/login" class="text-sm text-green">{{ $t('login.Log_in') }}?</router-link>                                        
                                    </div>                                    
                                </form>                                                       
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <auth-footer />
    </div>
</template>
  
<script>
import axios from 'axios'
import AuthFooter from './Footer.vue';

export default {
    name: "Mfa_verify",
    components: {
        AuthFooter
    },
    data()
        {
            return {
                code: '',
                attemptedLogin: false,
                errorMessage: '',
                deviceType:'',                
                userHostName:'',
                userHostIp:'',
                computerName:'',
                posts: []
            }
        },    
    mounted() {
        this.detectDeviceType();
        this.getUserHostIp();
    },
    computed: {        
    },   
    methods: {        
        detectDeviceType() {
            const userAgent = navigator.userAgent.toLowerCase();
            if (/mobile|android|iphone|ipad|phone/i.test(userAgent)) {
                this.deviceType = 'Mobile';
            } else {
                this.deviceType = 'Desktop';
            }
        },
        async getUserHostIp() {
            try {
                const response = await axios.get('https://api.ipify.org?format=json');
                this.userHostIp = response.data.ip;
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
        },
        async verifyMfa() {
            try {
                this.attemptedLogin = true;

                if (!this.code) {
                    return;
                }
                
                this.$store.commit('setShowLoading', true);   
        
                const mfaSessionId = sessionStorage.getItem('mfaSessionId');

                const response = await axios.post("Auth/verify-mfa", { 
                    mfaSessionId: mfaSessionId,
                    code : this.code,
                    deviceType : this.deviceType,
                    userAgent : navigator.userAgent,
                    userHostName : this.userHostName,
                    userHostIp : this.userHostIp,
                    computerName : this.computerName 
                });

                this.posts = response.data;
                if(this.posts.success) {
                    
                    // Persist token and user data until tab/browser is closed
                    sessionStorage.setItem('sheepbase-token', this.posts.token);
                    sessionStorage.setItem('user', JSON.stringify(this.posts.user));
                    sessionStorage.setItem('roleName', this.posts.user.roleName);
                                        
                    // Store today's date in localStorage for next-day expiration
                    const today = new Date().toDateString(); // e.g. "Mon Apr 22 2025"
                    localStorage.setItem('login-date', today);
                    
                    // Commit to Vuex
                    this.$store.commit('setShowNavbar', true);
                    this.$store.commit('user', this.posts.user);
                    
                    this.$store.commit('setRoleName', this.posts.user.roleName);

                    if(this.posts.user.roleName == 'Keeper') {
                        this.$store.commit('setKeeperAssociationId', this.posts.user.keeperAssociationId);
                        this.$store.commit('setKeeperRVORelationNumber', this.posts.user.keeperRVORelationNumber);
                        this.$store.commit('setKeeperRVOConnected', this.posts.user.keeperRVOConnected);
                    }
                    
                    if(this.posts.user.roleName == 'AssociationAdmin') {
                        this.$store.commit('setAssociationAdminAssociationId', this.posts.user.associationAdminAssociationId);
                    }
                    
                    this.$store.commit('setAssociationWebsiteURL', this.posts.user.associationWebsiteURL);

                    // Set Axios defaults
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.posts.token;

                    // Navigate to dashboard or home
                    this.$router.push('/');

                } else {
                    const errorMessage = this.posts.message || this.$t('error.Invalid_or_expired_MFA_code');
                    this.$showError(`${errorMessage}`);

                    this.$router.push('/login');
                }
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);

                this.$router.push('/login');
            } finally {
                this.$store.commit('setShowLoading', false); 
            }
        },
    }
};
</script>
<style src="@/assets/css/auth.css"></style>
  